export default __webpack_public_path__ + "static/media/fontsize.33ca03e1.svg";